<template>
  <div>
    <Transition name="slide-left" mode="out-in" appear>
      <SmartLink v-if="ready" :key="preloadedBanner.img.src" :to="to" :href="href" :nick="downloadNick" :soft="soft">
        <picture class="d-flex justify-center align-center">
          <source
            v-for="(item, ind) in preloadedBanner.sources"
            :key="ind"
            :srcset="item.srcset"
            :media="item.media"
            :type="item.type"
            :width="item.width"
            :height="item.height"
          />
          <img v-bind="img" :style="style" />
        </picture>
      </SmartLink>
    </Transition>
  </div>
</template>
<script setup>
// import { friendlyCountryBrand } from "@/apollo/queries/FriendlyCountries.gql";
const props = defineProps({
  preloaded: { type: Object, default: null },
  alt: { type: String, default: "Offer" },
  to: { type: String, default: "" },
  href: { type: String, default: "" },
  soft: { type: String, default: "" },
  nick: { type: String, default: "" },
  geo: { type: Array, default: () => [] },
});

const country = inject("navigatorCountry");
const friendlyCountryBanner = inject("friendlyCountryBanner");
const friendlyCountries = inject("friendlyCountries");
const preloadedBanner = ref(props.preloaded || {});
const downloadNick = ref(props.nick);
const style = ref(unref(preloadedBanner)?.img?.style || "width:100%;height:auto;");
const img = ref(_.omit(unref(preloadedBanner)?.img, ["style"]));

onMounted(() => {
  if (
    friendlyCountries.value.includes(country.value) &&
    props.geo.includes(unref(country)) &&
    !props.geo.includes("ZZ") &&
    unref(friendlyCountryBanner)?.preloaded
  ) {
    preloadedBanner.value = unref(friendlyCountryBanner)?.preloaded;
    downloadNick.value = unref(friendlyCountryBanner)?.nick;
    style.value = unref(preloadedBanner)?.img?.style || "width:100%;height:auto;";
    img.value = _.omit(unref(preloadedBanner)?.img, ["style"]);
  }
});

const ready = unref(preloadedBanner) && (!!props.nick || !!props.soft || !!props.to || !!props.href);
const fullURL = (url, hostname) => {
  const link = new URL(url, hostname);
  return link.href;
};
</script>
<style scoped>
/* Slide left */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition:
    opacity 0.8s ease,
    transform 0.8s ease;
}
.slide-left-enter-from {
  opacity: 0;
  transform: translateX(70%);
}

.slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-left-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-70%);
}

/* ensure block-level so transform works */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-left-enter-from,
.slide-left-enter-to,
.slide-left-leave-from,
.slide-left-leave-to {
  display: block;
}
</style>
